module.exports = __webpack_public_path__ + "img/battle_rooms_mobile.f41ce698.svg";